import { connect } from "react-redux";
import * as Redux from "redux";
import { withRouter } from "react-router-dom";
import {
  getToplineMetrics,
  setMetricContentView,
  setMetricContentCompareBy,
  setMetricContentGroupBy,
  getMetricData,
  getFlyers,
  setSelectedFlyerId,
  getFlyerItems,
  clearFlyerItems
} from "../../actions";
import MetricView from "./component";
import { selectedFlyer, isMerchantUSBased } from "../../selectors";
import { getUserContext } from "../../../User/selectors";
import {
  getViewContext,
  currentMerchantName
} from "../../../Analytics/selectors";
import { GAContextProps } from "../../../Analytics";

export interface MetricViewProps {
  merchant_id: number;
  us_based: boolean;
  publication_ids: number[];
  start_date: string;
  end_date: string;
  metric: string;
  metrics_container_tab: string;
  metric_data: any[];
  group_by: string;
  compare_by: string;
  view: string;
  toplineMetrics: any;
  analyticMetrics: any;
  flyers: any[];
  selectedFlyer: any;
  flyerItems: any[];
  flyer_items_loading: boolean;
  metric_data_loading: boolean;
  topline_metrics_loading: boolean;
  permissions: any;
  features: any;
  gaUserContext: any;
  gaViewContext: any;
}

export interface MetricViewActions {
  setMetricContentView: (selection: string) => void;
  setMetricContentCompareBy: (selection: string) => void;
  setMetricContentGroupBy: (selection: string) => void;
  getMetricData: (
    endpoint: number,
    metric: string,
    merchant_id: number,
    us_based: boolean,
    flyer_run_ids: number[],
    group_by: string,
    compare_by: string,
    start_date: string,
    end_date: string,
    state_level: boolean
  ) => void;
  getToplineMetrics: (
    metric: string,
    merchant_id: number,
    start_date: string,
    end_date: string
  ) => void;
  getFlyers: (flyerRunIds: number[], setDefault: boolean) => void;
  setSelectedFlyerId: (id: number) => void;
  getFlyerItems: (
    flyerId: number,
    metrics: string[],
    startDate: string,
    endDate: string,
    groupBy: string
  ) => void;
  clearFlyerItems: () => void;
}

export interface MetricViewStateProps {
  merchant_id: number;
  us_based: boolean;
  publication_ids: number[];
  start_date: string;
  end_date: string;
  metric: string;
  metric_data: any[];
  group_by: string;
  compare_by: string;
  view: string;
  toplineMetrics: any;
  analyticMetrics: any;
  flyers: any[];
  selectedFlyer: any;
  flyerItems: any[];
  flyer_items_loading: boolean;
  metric_data_loading: boolean;
  topline_metrics_loading: boolean;
  permissions: any;
  features: any;
  gaUserContext: any;
  gaViewContext: any;
}

export interface MetricViewActionsProps {
  setMetricContentView: (selection: string) => void;
  setMetricContentCompareBy: (selection: string) => void;
  setMetricContentGroupBy: (selection: string) => void;
  getMetricData: (
    endpoint: number,
    metric: string,
    merchant_id: number,
    us_based: boolean,
    flyer_run_ids: number[],
    group_by: string,
    compare_by: string,
    start_date: string,
    end_date: string,
    state_level: boolean
  ) => void;
  getToplineMetrics: (
    metric: string,
    merchant_id: number,
    start_date: string,
    end_date: string
  ) => void;
  getFlyers: (flyerRunIds: number[], setDefault: boolean) => void;
  setSelectedFlyerId: (id: number) => void;
  getFlyerItems: (
    flyerId: number,
    metrics: string[],
    startDate: string,
    endDate: string,
    groupBy: string
  ) => void;
  clearFlyerItems: () => void;
}

const mapStateToProps = (
  state: any,
  props: any
): MetricViewStateProps & GAContextProps => {
  return {
    start_date: state.analytics.start_date,
    end_date: state.analytics.end_date,
    merchant_id: state.analytics.merchant_id,
    us_based: isMerchantUSBased(state, props),
    publication_ids: state.analytics.publication_ids,
    metric_data: state.analytics_metric.metric_data,
    metric: state.analytics.metrics_container_tab,
    group_by: state.analytics_metric.group_by,
    compare_by: state.analytics_metric.compare_by,
    view: state.analytics_metric.view,
    toplineMetrics: state.analytics_metric.toplineMetrics,
    analyticMetrics: state.analytics.analytics_metrics,
    flyers: state.analytics_metric.flyers,
    selectedFlyer: selectedFlyer(state),
    flyerItems: state.analytics_metric.flyerItems,
    flyer_items_loading: state.analytics_metric.flyer_items_loading,
    metric_data_loading: state.analytics_metric.metric_data_loading,
    topline_metrics_loading: state.analytics_metric.topline_metrics_loading,
    permissions: state.user.permissions,
    merchantName: currentMerchantName(state),
    gaUserContext: getUserContext(state),
    gaViewContext: getViewContext(state),
    features: state.user.features
  };
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): MetricViewActions => {
  return {
    ...Redux.bindActionCreators(
      {
        setMetricContentView,
        setMetricContentCompareBy,
        setMetricContentGroupBy,
        getToplineMetrics,
        getMetricData,
        getFlyers,
        setSelectedFlyerId,
        getFlyerItems,
        clearFlyerItems
      },
      dispatch
    )
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetricView)
);



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/MetricView/container.ts